const AMP_KEYS = {
  // COMMON
  PAGE_VIEW: 'page_view', // pathname, query, isModal

  // ONBOARDING
  ONBOARDING_STEP_COMPLETE: 'onboarding/step/complete', // step
  ONBOARDING_STEP_UNDO: 'onboarding/step/undo', // to
  ONBOARDING_LANGUAGE_SET: 'onboarding/language/set', // lang
  ONBOARDING_DATA_ANONYMIZATION_TOGGLE: 'onboarding/data_anonymization/toggle', // status

  // HOME
  HOME_GUIDE_IMPORT_CSV_CLICK: 'home/guide/import_csv/click',
  HOME_GUIDE_INTEGRATE_CLICK: 'home/guide/integrate/click',
  HOME_GUIDE_CREATE_TOPIC_CLICK: 'home/guide/create_topic/click',
  HOME_GUIDE_DISMISS_CLICK: 'home/guide/dismiss/click',

  // FEEDBACK
  FEEDBACK_LIST_VIEW_SEARCH: 'feedback/search', // search
  FEEDBACK_MANUAL_ADD_CLICK: 'feedback/manual_add/click',
  FEEDBACK_CSV_UPLOAD_CLICK: 'feedback/csv_upload/click',

  // DATA_FILTER
  DATA_FILTER_CLICK: 'data_filter/click', // tableName
  DATA_FILTER_PROPERTY_SELECT: 'data_filter/property/select', // tableName, property

  // DASHBOARD_LIST
  DASHBOARD_LIST_CREATE_DASHBOARD_CLICK:
    'dashboard_list/create_dashboard/click',
  DASHBOARD_LIST_CREATE_FOLDER_CLICK: 'dashboard_list/create_folder/click',

  // DASHBOARD_DETAIL
  DASHBOARD_DETAIL_CREATE_DASHBOARD_CLICK:
    'dashboard_detail/create_dashboard/click',
  DASHBOARD_DETAIL_SHARE_CLICK: 'dashboard_detail/share/click',
  DASHBOARD_DETAIL_ADD_CHART_CLICK: 'dashboard_detail/add_chart/click',
  DASHBOARD_DETAIL_DELETE_DASHBOARD_CLICK: 'dashboard_detail/delete/click',
  DASHBOARD_DETAIL_RENAME_DASHBOARD_CLICK: 'dashboard_detail/rename/click',
  DASHBOARD_DETAIL_EXPORT_TO_PDF_CLICK: 'dashboard_detail/export_to_pdf/click',
  DASHBOARD_DETAIL_DUPLICATE_DASHBOARD_CLICK:
    'dashboard_detail/duplicate/click',
  DASHBOARD_CARD_EMPTY_CLICK: 'dashboard_card/empty/click',
  DASHBOARD_FROM_SAVED_CHART_CLICK: 'dashboard/from_saved_chart/click',
  DASHBOARD_CREATE_NEW_CHART_CLICK: 'dashboard/create_new_chart/click',
  DASHBOARD_ADD_TITLE_CLICK: 'dashboard/add_title/click',
  DASHBOARD_ADD_DESC_CLICK: 'dashboard/add_desc/click',

  DASHBOARD_CARD_CHART_TITLE_CLICK: 'dashboard_card/chart_title/click',

  DASHBOARD_CARD_ELLIPSIS_CLICK: 'dashboard_card/ellipsis/click',
  DASHBOARD_CARD_REMOVE_DASHBOARD_CLICK:
    'dashboard_card/remove_dashboard/click',
  DASHBOARD_CARD_ASK_SYNCLY_CLICK: 'dashboard_card/ask_syncly/click',
  DASHBOARD_EXPORT_AS_REPORT_CLICK: 'dashboard/export_as_report/click',

  // CUSTOMER
  CUSTOMER_SENTIMENT_SELECT: 'customer/sentiment/select', // sentiment
  CUSTOMER_DOMAIN_SELECT: 'customer/domain/select', // domain
  CUSTOMER_SEGMENT_SELECT: 'customer/segment/select', // segment
  CUSTOMER_SEGMENT_CLEAR: 'customer/segment/clear',
  CUSTOMER_PERIOD_SELECT: 'customer/period/select', // period

  // GLOBAL_SEARCH
  GNB_SEARCH_CLICK: 'gnb/explore/click',
  SEARCH_SHORTCUT: 'gnb/explore/shortcut',
  SEARCH_HISTORY_ITEM_CLICK: 'explore/history_item/click',
  SEARCH_SHARE_CLICK: 'explore/share/click',
  SEARCH_SUBMIT: 'explore/submit', // from: modal / float / detail / home
  SEARCH_CUSTOMER_SEGMENT_SELECT: 'explore/customer_segment/select', //domain: accounts | contacts,  segment: 각 column
  SEARCH_TAB_SELECT: 'explore/tab/select', // tab: feedback, topic, account, agent ...
  SEARCH_NEW_SEARCH_CLICK: 'explore/new_search/click',
  SEARCH_INLINE_ASK_SYNCLY_SUBMIT: 'explore/inline_ask_syncly/submit', // path
  SEARCH_MANAGE_VIEW_CLICK: 'explore/manage_view/click',
  SEARCH_FILTER_CHANGE: 'explore/filter/change', // filter: dateRange, prompt, keyword, feedbackFilter, frequency

  // TAXONOMY
  TAXONOMY_TOPIC_SEARCH: 'taxonomy/topic/search',
  TAXONOMY_CREATE_TOPIC_DONE: 'taxonomy/create_topic/done', // {type: Topic2Type}
  TAXONOMY_VIEW_INSIGHTS_CLICK: 'taxonomy/view_insights/click',

  // NAVIGATOR
  GNB_NAVIGATOR_CLICK: 'gnb/navigator/click',
  NAVIGATOR_SELECT: 'navigator/select', // target, name, alias
  NAVIGATOR_SHORTCUT: 'navigator/shortcut',

  //ASK_SYNCLY
  ASK_SYNCLY_SUBMIT: 'ask_syncly/submit', // domain: chart, search, search_summary, path
  ASK_SYNCLY_ANSWER_RECEIVED: 'ask_syncly/answer/received', // domain, response_time_ms, feedback_analyzed_count

  // HEY_SYNCLY
  HEY_SYNCLY_QUESTION_SUBMIT: 'hey_syncly/question/submit', // previous_prompt, filter_keys, prompt, path
  HEY_SYNCLY_ANSWER_RECEIVED: 'hey_syncly/answer/received', // chat_alias, message_id, feedback_analyzed_count, response_time_ms
  HEY_SYNCLY_ANSWER_ACTIONS: 'hey_syncly/answer/action', // prompt, action: copy, vote_up, vote_down
  HEY_SYNCLY_NEW_CHAT_CLICK: 'hey_syncly/new_chat/click',

  HEY_SYNCLY_TOOL_SELECT: 'hey_syncly/tool/select', // type: DOC, TOPIC_MAP ...
  HEY_SYNCLY_STUDIO_ITEM_CLICK: 'hey_syncly/studio_item/click', // chat_alias, item_alias,

  // STUDIO
  STUDIO_ITEM_TEMPLATE_SELECT: 'studio/item/template/select', // template_type
  STUDIO_ITEM_CREATE_CLICK: 'studio/item/create/click', // template_type,

  // from: list | detail | in_chat
  STUDIO_ITEM_DELETE_CLICK: 'studio/item/delete/click', // from
  STUDIO_ITEM_RENAME_CLICK: 'studio/item/rename/click', // from, alias, title, new_title
  STUDIO_ITEM_SAVE_TO_STUDIO_CLICK: 'studio/item/save_to_studio/click', // item_alias
  STUDIO_ITEM_COPY_CLICK: 'studio/item/copy/click', // from
  STUDIO_ITEM_VOTE_UP_CLICK: 'studio/item/vote_up/click', // from, alias
  STUDIO_ITEM_VOTE_DOWN_CLICK: 'studio/item/vote_down/click', // from, alias
  STUDIO_ITEM_SOURCE_VIEW_CLICK: 'studio/item/source_view/click', // from

  // CHART
  CHART_CREATE_COMPLETE: 'chart/create/complete', // chart_alias, chart_type, graph_type
  CHART_VIEW_INSIGHT_CLICK: 'chart/view_insight/click', // chart_alias, chart_type
  CHART_SAVE_TO_DASHBOARD_COMPLETE: 'chart/save_to_dashboard/complete', // chart_alias, dashboard_alias
  CHART_ANALYSIS_ANSWER_RECEIVED: 'chart/analysis_answer/received', // analysis_alias, chart_alias, response_time_ms

  // FEEDBACK
  FEEDBACK_UPLOAD_COMPLETE: 'feedback/upload/complete', // feedback_count, upload_type
  FEEDBACK_DETAIL_BLOCK_FILTER_APPLY: 'feedback/detail/block_filter/apply', // feedback_alias, block_count, filter_type
  FEEDBACK_EXPORT_COMPLETE: 'feedback/export/complete', // export_format, has_filter
  FEEDBACK_MANUAL_CREATE_COMPLETE: 'feedback/manual_create/complete', // feedback_alias, has_tags, has_sentiment

  // INTEGRATION
  INTEGRATION_ATTEMPT_START: 'integration/attempt/start', // integration_type

  // FILTER
  FILTER_APPLY_COMPLETE: 'filter/apply/complete', // filter_count, filter_types, page

  // SEARCH
  SEARCH_COMPLETE: 'search/complete', // search_alias, has_filter

  // COMPANY (ACCOUNT)
  COMPANY_UPLOAD_COMPLETE: 'company/upload/complete', // company_count, upload_type

  // CUSTOMER (CONTACT)
  CUSTOMER_UPLOAD_COMPLETE: 'customer/upload/complete', // customer_count, upload_type

  // REPORT
  REPORT_CREATE_COMPLETE: 'report/create/complete', // report_alias, dashboard_alias, report_type
  REPORT_SHARE_LINK_COPY_COMPLETE: 'report/share_link_copy/complete', // report_alias

  // WORKFLOW
  WORKFLOW_SETUP_COMPLETE: 'workflow/setup/complete', // workflow_alias, workflow_type, trigger_count

  // INSIGHT_EXPLORER
  INSIGHT_EXPLORER_ANSWER_RECEIVED: 'insight_explorer/answer/received', // request_type, response_time_ms, feedback_analyzed_count
  INSIGHT_EXPLORER_VIEW_SELECT: 'insight_explorer/view/select', // view: volume, sentiment
  INSIGHT_EXPLORER_FIELD_SELECT: 'insight_explorer/field/select', // field: taxonomy, tag
  INSIGHT_EXPLORER_TREND_VIEW_SELECT: 'insight_explorer/trend_view/select', // trend_view: negative_volume, sentiment_score
  INSIGHT_EXPLORER_ASK_SYNCLY_SUBMIT: 'insight_explorer/ask_syncly/submit', // request_type: QEUSTION, SUMMARY // prompt: string, path
  INSIGHT_EXPLORER_INCLUDE_OVERALL_TOGGLE:
    'insight_explorer/include_overall/toggle', // include_overall: true, false
  INSIGHT_EXPLORER_TOP_SELECT: 'insight_explorer/top/select', // top: number
  INSIGHT_EXPLORER_VIEW_DETAIL_CLICK: 'insight_explorer/view_detail/click', // node_type: taxonomy, tag, topic // name: string
  INSIGHT_EXPLORER_FEEDBACK_LIST_CLICK: 'insight_explorer/feedback_list/click', // node_type: taxonomy, tag, topic // name: string
  INSIGHT_EXPLORER_ASK_SYNCLY_CLICK: 'insight_explorer/ask_syncly/click', // node_type: taxonomy, tag, topic // name: string
  INSIGHT_EXPLORER_CHILD_ASK_SYNCLY_CLICK:
    'insight_explorer/child/ask_syncly/click',
  INSIGHT_EXPLORER_DATE_FILTER_CHANGE: 'insight_explorer/date_filter/change', // date_range: 24h, 7d, 30d
  INSIGHT_EXPLORER_FILTER_CHANGE: 'insight_explorer/filter/change', // column: string, value: string
  INSIGHT_EXPLORER_FILTER_CLEAR: 'insight_explorer/filter/clear',
  INSIGHT_EXPLORER_KEYWORD_FILTER_ENTER:
    'insight_explorer/keyword_filter/enter', // keyword: string
  INSIGHT_EXPLORER_NODE_SELECT: 'insight_explorer/node/select', // node_type: taxonomy, tag, topic // node_name: string
  INSIGHT_EXPLORER_NODE_SEARCH_ENTER: 'insight_explorer/node/search/enter', // keyword: string
  INSIGHT_EXPLORER_CHART_TOOLTIP_CLICK: 'insight_explorer/chart_tooltip/click', // node_type: taxonomy, tag, topic // name: string // from: total, subtopic

  // SIGNAL
  SIGNAL_ISSUE_DETAIL_VIEW: 'signal/issue_detail/view', // issue_name, severity, view_type: 'row_click' | 'menu'
  SIGNAL_VIEW_TYPE_CHANGE: 'signal/view_type/change', // view_type: 'list' | 'matrix' | 'chart'
  SIGNAL_ISSUE_FAVORITE: 'signal/issue/favorite', // issue_name
  SIGNAL_DATE_PRESET_CHANGE: 'signal/date_preset/change', // date_preset
  SIGNAL_CUSTOM_CHART_FIELD_CHANGE: 'signal/custom_chart_field/change', // issue_name, field_type, field_items_count, graph_direction, graph
  SIGNAL_ISSUE_SHARE: 'signal/issue/share', // issue_name
  SIGNAL_ISSUE_EXPORT_PDF: 'signal/issue/export_pdf', // issue_name
  SIGNAL_CLICK_ASK_SYNCLY: 'signal/click_ask_syncly', // issue_name
  SIGNAL_ALERT_CREATE: 'signal/alert/create', // alert_title, preset_alias, preset_filter_dataset_name, preset_name, channel_type
};

export default AMP_KEYS;
